import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { ImagesBanner } from 'src/app/enums/images-banner.enum';
import { ImageBanner } from 'src/app/interfaces/image-banner.interface';
import Swiper from 'swiper';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  gallery = ContentPage.esES.banner;
  content = ContentPage.esES;
  showPopup = true;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.gallery = language == 'esEN' ? ContentPage.esEN.banner : ContentPage.esES.banner;
      this.content = language == 'esEN' ? ContentPage.esEN : ContentPage.esES;
    }
  }

  closePopup() {
    this.showPopup = false;
  }

  ngAfterViewInit(){
    this.initSwiper();
  }

  initSwiper(){
    new Swiper('.gallery-top', {
      spaceBetween: 10,
      autoplay: true,
      loop : true,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true, // Permite hacer clic en los puntos de paginación para cambiar de slide
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  goTo(index:number){
    this.router.navigateByUrl(`/productos/${index}`)
  }

}
